import { Button, Stack, Tooltip, Typography } from '@mui/material'
import type { DiscountItemObject } from '../api/api'
import { BorderedStack } from '../components/BorderedStack'
import { DiscountItems, type DiscountItemsProps } from '../usecases/DiscountItems'

export interface CustomerDiscountProps {
  items: { data: DiscountItemObject[]; isLoading: boolean }
  onCreateDiscount: () => void
  onDeleteDiscount: (id: DiscountItemObject['id']) => Promise<void>
  format: DiscountItemsProps['format']
  canCreateDiscount: boolean
  getDiscountLabel: (discountType: string) => string
}

export const CustomerDiscount = (props: CustomerDiscountProps) => {
  const { data: items = [], isLoading: isLoadingItems } = props.items

  return (
    <BorderedStack
      sx={{
        padding: 2,
        gap: 2,
      }}
    >
      <Typography variant="p2Medium">Line item discounts</Typography>
      <DiscountItems
        format={props.format}
        isLoading={isLoadingItems}
        items={items}
        onDeleteDiscount={props.onDeleteDiscount}
        getDiscountLabel={props.getDiscountLabel}
      />
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <Tooltip title={!props.canCreateDiscount ? 'There are no products you can create a discount on' : ''} placement="top">
          <span>
            <Button
              aria-label="add-product"
              variant="contained"
              size="medium"
              type="button"
              onClick={props.onCreateDiscount}
              disabled={!props.canCreateDiscount}
            >
              Create discount
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </BorderedStack>
  )
}
